<div class="modal-body form-modal-body">
  <div class="skylark-modal-header">
    <h4>Approve Schedule</h4>
    <button type="button" class="icon" (click)="closeModal()"><span class="pi pi-times"></span></button>
  </div>
  <div class="form-group">

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label><b>Scheduled Start Time</b></label>
          <p>{{scheduleItem.startTime | date: 'dd/MM/yyyy HH:mm'}}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label><b>Scheduled End Time</b></label>
          <p>{{scheduleItem.endTime | date: 'dd/MM/yyyy HH:mm'}}</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label><b>Note</b></label>
          <p>{{scheduleItem.reason}}</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label><b>Created By</b></label>
          <p>{{scheduleItem.createdBy}}</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label><b>Created On</b></label>
          <p>{{scheduleItem.createdDate | date: 'dd/MM/yyyy HH:mm'}}</p>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="showRejectionForm">
    <p><b>Let the Worker know why this was rejected</b></p>

    <div class="form-row">
      <div class="col-md-12">
        <div class="form-group">
          <label><b>Comment</b></label>
          <textarea type="text" class="form-control" style="height: 120px; max-height: none; resize: vertical;" [(ngModel)]="rejectionForm"></textarea>
          <small class="form-text text-muted text-right">{{ rejectionForm.length }} / {{ rejectionCommentMaxLength }} characters</small>
          <div *ngIf="rejectionCommentTooLong" class="text-danger">
            Comment must be 350 characters or fewer.
          </div>
        </div>
      </div>
    </div>
    <button type="submit" class="btn btn-success btn-round btn-round-action float-right mr-2" [disabled]="saveInProgress || !(rejectionForm || '').trim() || rejectionCommentTooLong" (click)="saveRejection()">Reject</button>
    <button type="button" class="btn btn-link btn-link-cancel float-right" [disabled]="saveInProgress" (click)="cancelRejection()">
      <i class="fas fa-times"></i>
      Cancel
    </button>
    <br>
  </ng-container>

  <p-footer>
    <ng-container *ngIf="!showRejectionForm">
      <button type="button" class="btn btn-danger btn-round btn-round-action float-right" [disabled]="saveInProgress" (click)="reject()">Reject</button>
      <button type="button" class="btn btn-success btn-round btn-round-action float-right" [disabled]="saveInProgress" (click)="approve()">Approve</button>
    </ng-container>
  </p-footer>
</div>
